const attributes: Record<"block" | "button", string> = {
  block: "data-corporate-distributor-list",
  button: "data-corporate-distributor-list-trigger",
};

const selectors: Record<"block" | "buttons", string> = {
  block: `[${attributes.block}]`,
  buttons: `[${attributes.button}]`,
};

const statuses: Record<"active", string> = {
  active: "active",
};

function init() {
  const buttons = Array.from(document.querySelectorAll(selectors.buttons) || []) as HTMLElement[];

  if (!buttons.length) return;

  buttons.forEach((button) =>
    button.addEventListener("click", (e) => {
      const block = button.closest(selectors.block) as HTMLElement;

      if (!block) return;
      const isActive = block.getAttribute(attributes.block) === statuses.active;
      block.setAttribute(attributes.block, isActive ? "" : statuses.active);
    })
  );
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
